import * as React from 'react';
import { StandardLocalWidget, any, fromJSX } from "widgets-for-react";
import { SubscriptionLayout } from "subscription/subscriptionLayout";
import { DataLayer, PIIData } from 'utils/datalayer';
import { SubscriptionSelectorState, subscriptionSelectorStateUpdaters } from "./subscriptionSelectorState";
import { Subscription } from "subscription/subscriptionState";

export const subscriptionSelectorWidget = (availableSubscriptions: Array<Subscription>, pageKind: 'account-details' | 'trial-to-pro', piiData?: PIIData): StandardLocalWidget<SubscriptionSelectorState> => currentState =>
  any([
    currentState.validator.widget().map(subscriptionSelectorStateUpdaters.validation),
    fromJSX(setState =>
      <SubscriptionLayout.SubscriptionChoice
        kind={pageKind}
        availableSubscriptions={availableSubscriptions}
        currentSubscription={currentState.input}
        select={s => {
          setState(subscriptionSelectorStateUpdaters.input(_ => s))
          DataLayer.upgradeFlowStep1(false, piiData, s.PaymentFrequency)
        }}
      />
    )
  ])
